"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TableHeading_1 = __importDefault(require("components/common/table/TableHeading"));
var DeliveryCostsTableRow_1 = __importDefault(require("./DeliveryCostsTableRow"));
var DeliveryCostsTable = function (_a) {
    var sort = _a.sort, data = _a.data, onChangeSort = _a.onChangeSort, onDelete = _a.onDelete;
    return (react_1.default.createElement("div", { className: 'table' },
        react_1.default.createElement("div", { className: 'table__head flex flex-row' },
            react_1.default.createElement(TableHeading_1.default, { name: 'Cost', sortable: true, active: sort.name === 'Cost', direction: sort.direction, onChange: onChangeSort }),
            react_1.default.createElement(TableHeading_1.default, { name: 'Delivery Type', sortable: true, active: sort.name === 'Delivery Type', direction: sort.direction, onChange: onChangeSort }),
            react_1.default.createElement(TableHeading_1.default, { name: 'Reference Code', sortable: true, active: sort.name === 'Reference Code', direction: sort.direction, onChange: onChangeSort }),
            react_1.default.createElement(TableHeading_1.default, { name: 'Action', sortable: false })),
        react_1.default.createElement("div", { className: 'table__body' },
            data.length > 0 &&
                data.map(function (deliveryCost) { return (react_1.default.createElement(DeliveryCostsTableRow_1.default, { onDelete: onDelete, key: deliveryCost.id, data: deliveryCost })); }),
            data.length <= 0 &&
                react_1.default.createElement("p", { className: 'table__empty' }, "There are no delivery costs to show"))));
};
exports.default = DeliveryCostsTable;
